import {
  getUserSelectedInfo,
  reloadPage,
  clearCacheAndReloadPage,
  isDisableUserSelectLocationAction,
} from './../helpers';
import { useGlobalData } from 'contexts';
import { useEffect, useState } from 'react';
import { userSelectedConstants } from '../constants';
import { setUserSelectedInfo } from '../helpers';
import { Body } from '@teko/ds-desktop';
import { Terminal } from 'types';

export const useRegionPicker = () => {
  const {
    isMobile,
    originalTerminal,
    clearCacheAfterSwitchLocation,
    isDmsFlow,
  } = useGlobalData();
  const terminals = originalTerminal || [];

  const selectedTerminal = getUserSelectedInfo(
    userSelectedConstants.TERMINAL,
    isMobile,
  );
  const selectedLocation = getUserSelectedInfo(
    userSelectedConstants.LOCATION,
    isMobile,
  );
  const selectedTerminalId = getUserSelectedInfo(
    userSelectedConstants.TERMINAL_ID,
    isMobile,
  );
  const enableLocationFeature = terminals.every((item) => !!item.locationCode);
  const confirmedOptionIndex = terminals.findIndex((item) => {
    if (enableLocationFeature) {
      return (
        item.code === selectedTerminal && item.locationCode === selectedLocation
      );
    }
    return item.code === selectedTerminal;
  });
  const [showRegionPopup, setShowRegionPopup] = useState(false);
  const [selected, setSelected] = useState(
    confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex,
  );
  const isDisableUserSelectLocation = isDisableUserSelectLocationAction({
    isDmsFlow,
  });

  const selectTerminal = (terminal: Terminal) => {
    setUserSelectedInfo(
      userSelectedConstants.TERMINAL,
      terminal.code,
      isMobile,
    );
    setUserSelectedInfo(
      userSelectedConstants.TERMINAL_ID,
      terminal?.id?.toString(),
      isMobile,
    );
    enableLocationFeature &&
      setUserSelectedInfo(
        userSelectedConstants.LOCATION,
        // remove after 284 --> ignore now
        // @ts-ignore
        terminal.locationCode,
        isMobile,
      );
  };
  const onSubmitNewLocation = () => {
    selectTerminal(terminals[selected]);
    if (clearCacheAfterSwitchLocation) {
      clearCacheAndReloadPage();
    } else {
      reloadPage();
    }
  };
  const activeLocation =
    confirmedOptionIndex || confirmedOptionIndex === 0
      ? terminals[confirmedOptionIndex]
      : undefined;
  const textMsg = `Vui lòng chọn khu vực để chúng tôi sắp xếp giao hàng cho bạn nhanh nhất.`;
  // temporarily rely on the location object present terminal
  const useDropdownPicker = !!terminals[0]?.location;
  const onClosePopup = () => {
    if (activeLocation) {
      setShowRegionPopup(false);
      setSelected(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex);
    }
  };

  useEffect(() => {
    // terminalId is a new key added later
    // we want to deprecate terminalCode
    // so for site without terminalId, prompt region picker
    const isTerminalSelected =
      !!selectedTerminal &&
      !!selectedTerminalId &&
      // ensure id and code are included in the workload configuration
      !!terminals.find(({ code, id }) => {
        return code === selectedTerminal && id === parseInt(selectedTerminalId);
      });
    // if terminals include just one element --> auto set this element
    if (terminals.length === 1 && !isTerminalSelected) {
      selectTerminal(terminals[0]);
    } else {
      // add check !activeLocation in case the list of locations changes
      // on server-side, and user
      setShowRegionPopup(
        enableLocationFeature
          ? !isTerminalSelected || !selectedLocation || !activeLocation
          : !isTerminalSelected,
      );
    }
  }, [selectedTerminal, selectedLocation, selectedTerminalId]);
  return {
    showPopup: !isDisableUserSelectLocation && showRegionPopup,
    setShowPopup: setShowRegionPopup,
    onOpenPopup: () => setShowRegionPopup(true),
    onClosePopup,
    selected,
    setSelected,
    terminals,
    locationOptions: terminals.map((el, index) => ({
      text: el.label,
      value: index,
    })),
    onSubmitNewLocation,
    activeLocation,
    useDropdownPicker,
    title: <Body level={1}>{textMsg}</Body>,
    isShowLocationIcon: !isDisableUserSelectLocation,
  };
};
